const initialState = {
    chosenRecProject: ""
}

function projectReducer(state = initialState, action) {
    switch (action.type) {
        case 'SET_REC_PROJECT':
            return {
                ...state,
                chosenRecProject: action.payload
            }
        default:
            return state
    }
}

export default projectReducer